import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Mic, ShieldCheck, ClipboardList, ArrowUpRight } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1751921661682-3eba30ea453a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwdGVycmF6em8lMjB0ZXh0dXJlfGVufDB8fHx8MTc4Mzc2NTM3M3ww&ixlib=rb-4.1.0&q=85";

const APPS = [
  {
    role: "admin",
    label: "Admin",
    persona: "Arpan Goel · Co-founder",
    desc: "Full control — costs, feasibility reports, delete records, chat with Sango AI.",
    icon: ShieldCheck,
    accent: "#C85A42",
    testid: "app-admin",
  },
  {
    role: "supervisor",
    label: "Supervisor",
    persona: "Mohit Gautam · Manager",
    desc: "Log production, materials, genset, dispatch. Add workers. See stock & schedule.",
    icon: ClipboardList,
    accent: "#5B7B61",
    testid: "app-supervisor",
  },
  {
    role: "worker",
    label: "Worker",
    persona: "Shop floor team",
    desc: "Just speak or type in Hindi/English — AI logs your work. Check-in & check-out.",
    icon: Mic,
    accent: "#1C1C1A",
    testid: "app-worker",
  },
];

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9F9F8] relative overflow-hidden">
      {/* subtle terrazzo bg strip */}
      <div className="absolute inset-x-0 top-0 h-72">
        <img src={BG} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#F9F9F8]" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 pt-14 pb-16">
        <header className="flex items-center justify-between">
          <div>
            <div className="text-[10px] tracking-[0.35em] uppercase text-[#6E6E6A]">Sango Terrazzo</div>
            <div className="font-display text-3xl tracking-tighter font-black text-[#1C1C1A]">STRONGER · BETTER · FOREVER</div>
          </div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#6E6E6A] hidden sm:block">Bareilly, UP · 243123</div>
        </header>

        <div className="mt-16 max-w-2xl">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#C85A42] mb-3 inline-flex items-center gap-2"><Sparkles className="w-3 h-3" /> Operations Suite</div>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tighter font-black text-[#1C1C1A] leading-[0.95]">
            Choose your<br/>console.
          </h1>
          <p className="text-[#6E6E6A] mt-4 text-sm sm:text-base leading-relaxed max-w-lg">
            Three tailored experiences for three roles. Bookmark your app on your device — it opens straight to sign-in.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
          {APPS.map((a, i) => {
            const Icon = a.icon;
            return (
              <button
                key={a.role}
                onClick={() => navigate(`/login?role=${a.role}`)}
                data-testid={a.testid}
                className="group text-left bg-white border border-[#D8D8D5] rounded-md p-6 hover:-translate-y-1 transition-transform relative overflow-hidden rise"
                style={{ animationDelay: `${i * 90}ms` }}
              >
                <div className="absolute top-0 left-0 h-1 w-full" style={{ background: a.accent }} />
                <div className="flex items-start justify-between mt-2">
                  <div
                    className="w-11 h-11 rounded-full flex items-center justify-center"
                    style={{ background: `${a.accent}15`, color: a.accent }}
                  >
                    <Icon className="w-5 h-5" strokeWidth={2.2} />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-[#6E6E6A] group-hover:text-[#1C1C1A] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
                <div className="mt-6">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#6E6E6A]">0{i + 1}</div>
                  <div className="font-display text-3xl font-black tracking-tighter text-[#1C1C1A] mt-1">{a.label}</div>
                  <div className="text-xs text-[#6E6E6A] mt-1">{a.persona}</div>
                </div>
                <p className="text-sm text-[#3A3A38] mt-5 leading-relaxed">{a.desc}</p>
                <div className="mt-6 text-[10px] tracking-[0.25em] uppercase text-[#6E6E6A] group-hover:text-[#1C1C1A]">
                  Open {a.label} console →
                </div>
              </button>
            );
          })}
        </div>

        <footer className="mt-20 pt-8 border-t border-[#D8D8D5] text-xs text-[#6E6E6A] flex flex-wrap gap-x-8 gap-y-2 justify-between">
          <span>Near FCI Godown, Village Rasuiya, Bareilly UP · 243123</span>
          <span>info@sangoconcrete.com · +91 8445950390</span>
        </footer>
      </div>
    </div>
  );
}
